import React from "react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const healthcareData = {
  badge: "HealthCare AI",
  title: "Healthcare AI Solutions",
  industry: "Healthcare",
  tagline: "Streamline patient care, automate scheduling, and reduce administrative overload with AI.",
  image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?auto=format&fit=crop&q=85&w=1200&h=800",
  cta: "Explore Healthcare Solutions",
  stats: [
    { number: "60%", label: "Better Patient Engagement" },
    { number: "35%", label: "Fewer No-Shows" },
    { number: "50%", label: "Admin Time Saved" },
    { number: "24/7", label: "Patient Communication" },
  ],
  problems: [
    {
      title: "Appointment Scheduling Overload",
      desc: "Staff spend hours managing appointments, reschedules, and reminders manually every day.",
    },
    {
      title: "Patient Engagement Gaps",
      desc: "Patients fall through the cracks due to lack of timely follow-up and communication.",
    },
    {
      title: "Follow-Up Management",
      desc: "Post-appointment follow-ups are inconsistent, leading to poor adherence and readmissions.",
    },
    {
      title: "Administrative Workload",
      desc: "Clinicians spend 30%+ of their time on paperwork instead of patient care.",
    },
  ],
  solutions: [
    {
      title: "AI Patient Assistants",
      desc: "24/7 AI assistants that answer patient queries, share health tips, and guide appointment booking.",
    },
    {
      title: "Appointment Automation Systems",
      desc: "Fully automated booking, reminders, rescheduling, and confirmation via voice and WhatsApp.",
    },
    {
      title: "Healthcare Workflow Agents",
      desc: "Intelligent agents that handle intake forms, referrals, and pre-appointment preparation.",
    },
    {
      title: "Patient Communication Platforms",
      desc: "Multi-channel patient engagement via WhatsApp, SMS, and voice calls — all automated.",
    },
  ],
  outcome:
    "Improve patient satisfaction scores by 60% and reduce no-show rates by 35% through intelligent, 24/7 patient engagement. Free your clinical staff from administrative burdens so they can focus entirely on delivering exceptional care.",
};

const HealthcarePage = () => <IndustryPageTemplate data={healthcareData} />;

export default HealthcarePage;
